<template>
  <footer class="app-footer" id="contact">
    <div class="app-footer__main">
      <div class="app-footer__content">
        <div class="app-footer__brand">
          <h2 class="app-footer__brand-name">BUZZRONIC</h2>
        </div>
        <div class="app-footer__contact">
          <div class="app-footer__contact-item">
            <span class="app-footer__contact-label">Company</span>
            <span>RM03, 24/F HO KING COMM CTR 2-16 FAYUEN ST MONG KOK HK</span>
          </div>
          <div class="app-footer__contact-item">
            <span class="app-footer__contact-label">Phone</span>
            <span>(+852)6219 1660</span>
          </div>
          <div class="app-footer__contact-item">
            <span class="app-footer__contact-label">Email</span>
            <span>dev@buzzronic.com</span>
          </div>
        </div>
      </div>
    </div>
    <div class="app-footer__copyright">
      Copyright © 2025 Buzzronic All Rights Reserved
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppFooter',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
    })
  },
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-footer {
	color: #ffffff;
	width: 100%;

	&__main {
		background: #161c2d;
		padding: rem(60) rem(180);
	}

	&__content {
		max-width: rem(1080);
		margin: 0 auto;
		flex-direction: column;
		gap: rem(52);
		display: flex;
		justify-content: space-between;
	}

	&__brand-name {
		font-size: rem(24);
		font-weight: 900;
		text-transform: uppercase;
	}

	&__contact {
		display: flex;
		flex-direction: column;
		gap: rem(24);
		text-align: right;
	}

	&__contact-item {
		display: flex;
		gap: rem(16);
		align-items: center;

		span:last-child {
			border-left: 1px solid rgba(255, 255, 255, 0.2);
			padding-left: rem(16);
			font-size: rem(14);
		}
	}

	&__contact-label {
		color: #848895;
		width: rem(80);
		text-align: left;
		font-size: rem(14);
	}

	&__copyright {
		color: #ffffff;
		font-size: rem(14);
		background: #008924;
		text-align: left;
		padding: rem(24) rem(180);
	}

	.detect_deviece_mobile & {
		&__main {
			padding: rem(60) rem(16);
		}

		&__content {
			flex-direction: column;
			gap: rem(40);
		}
		&__contact-label {
			display: block;
			flex-shrink: 0;
		}

		&__contact-item {
			flex-direction: row;
			align-items: flex-start;
			gap: rem(8);

			span:last-child {
				border-left: none;
				padding-left: 0;
				text-align: left;
			}
		}

		&__copyright {
			padding: rem(24) rem(16);
		}
	}
}
</style>
